import { createAction, props } from "@ngrx/store";
import { FranchiseProfileInterface } from "src/app/shared/models/franchise/franchise-profile.interface";
import { FranchiseMainDashboardDto } from "src/app/shared/models/franchise/FranchiseMainDashboardDto";
import { TopFranchisedResult, TopFranchiseRequest } from "src/app/shared/models/franchise/topFranchised.interface";
import { PaymentDetails } from "src/app/shared/models/franchise/paymentDetails.interface";
import { CreateFranchiseInterface } from "src/app/shared/models/franchise/createFranchise";
import { FranchiseResultInterface } from "src/app/shared/models/franchise/franchise-result.interface";
import { LocationPartnersFilterInterface } from "src/app/shared/models/location-partners/locationPartnersFilter.interface";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import { LocationPartnersResultInterface } from "src/app/shared/models/location-partners/locationPartnersResult.interface";
import { ComparatorRequestDto } from "src/app/shared/models/franchise/ComparatorRequestDto";
import { ComparatorSummary } from "src/app/shared/models/franchise/ComparatorSummary";

export const invokeFranchiseInfo = createAction(
  "[ Invoke Franchise profile Info ] Invoke Franchise profile info"
);

export const resultFranchiseInfo = createAction(
  "[ Result Franchise Info ] Result franchise info",
  props<{ franchiseInfo: FranchiseProfileInterface | null }>()
);

export const invokeUpdateFranchiseProfile = createAction(
  "[invoke Update Franchise Profile] invoke Update Franchise Profile",
  props<{ profile: FranchiseProfileInterface }>()
);

export const setUpdateProfileSuccess = createAction(
  "[Update Franchise Profile success] Update Franchise Profile success",
  props<{ success: SuccessDto | null }>()
);

export const invokeFranchisedCompanyNamesByFranchise = createAction(
  "[Invoke Franchised CompanyNames By Franchise] Invoke Franchised CompanyNames By Franchise",
  props<{ companyName: string }>()
)

export const resultFranchisedCompanyNamesByFranchise = createAction(
  "[result Franchised CompanyNames By Franchise] result Franchised CompanyNames By Franchise",
  props<{franchisedNamesList : string[]}>()
)

export const invokeMainDashboard = createAction(
  "[Invoke franchise main dashboard] Invoke franchise main dashboard",
  props<{ refreshCache: boolean }>()
)

export const resultMainDashboard = createAction(
  "[Result franchise main dashboard] Result franchise main dashboard",
  props<{ franchiseMainDashboardDto : FranchiseMainDashboardDto | null }>()
)

export const invokeTopFranchised = createAction(
  "[ Invoke top franchised ] Invoke top franchised",
  props<{refreshCache : boolean, request : TopFranchiseRequest }>()
)

export const resultTopFranchised = createAction(
  "[Result top franchised ] Result top franchised ",
  props<{ topFranchised : TopFranchisedResult | null }>()
)

export const invokeFranchiseList = createAction(
  "[ Invoke franchise list ] Invoke franchise list"
)

export const resultFranchiseList = createAction(
  "[Result franchise list ] Result franchise list",
  props<{ franchiseList : string[] }>()
)
export const invokePaymentDetails = createAction(
  "[Invoke payment details and global statistics for all franchised of a specific franchise] Invoke payment details and global statistics for all franchised of a specific franchise"
);

export const resultPaymentDetails = createAction(
  "[Result payment details and global statistics for all franchised of a specific franchise] Result payment details and global statistics for all franchised of a specific franchise",
  props<{ paymentDetails: PaymentDetails | null}>()
);

export const invokeCreateFranchise = createAction(
  "[Invoke Create Franchise] Invoke create Franchise",
  props<{ createFranchise: CreateFranchiseInterface }>()
);

export const createFranchiseSuccess = createAction(
  "[Create Franchise Success] Create Franchise success",
  props<{ successMessage: SuccessDto | null }>()
);

export const getFranchisesSuccess = createAction(
  "[Get Franchises By Filter Success] get filter Success",
  props<{ franchisesResult: FranchiseResultInterface | null }>()
);

export const invokeFranchiseFilter = createAction(
  "[invoke Franchise By Filter] invoke franchise by filter",
  props<{ franchiseFilter: LocationPartnersFilterInterface }>()
);

export const invokeFranchisesCompanyNames = createAction(
  "[invoke Franchises CompanyNames] invoke franchise CompanyNames"
);

export const setFranchisesCompanyNames = createAction(
  "[Set Franchises CompanyNames] set Franchise CompanyNames",
  props<{ companyNames: string[] | null }>()
);

export const invokeGetFranchiseInfoByCompanyName = createAction(
  "[Get Franchise Info by Company Name] get Franchise Info by Company Name",
  props<{ companyName: string }>()
);

export const invokeUpdateFranchise = createAction(
  "[Invoke Update Franchise Full Profile] Invoke update franchise full profile",
  props<{
    email: string | null;
    franchiseDto: LocationPartnerInterface | null;
  }>()
);

export const updateFranchiseSuccess = createAction(
  "[Update Franchise Success] Update franchise success",
  props<{ success: SuccessDto | null }>()
);

export const invokeDeleteFranchiseAndSomeLocations = createAction(
  "[Invoke Delete Franchise And Some Locations] invoke delete franchise and some locations",
  props<{ 
    franchise: string | null,
    locations: string[]
  }>()
);

export const setDeleteFranchiseSuccess = createAction(
  "[Delete Franchise Success] Delete franchise success",
  props<{ success: SuccessDto | null }>()
)

export const invokeLocationsByFranchise = createAction(
  "[Invoke Get Locations by Franchise] Invoke get locations by franchise",
  props<{ companyName: string | null }>()
);

export const resultFranchisedsByFranchise = createAction(
  "[result Franchised CompanyNames By Franchise] result Franchised CompanyNames By Franchise",
  props<{franchisedList : LocationPartnersResultInterface | null}>()
)

export const invokeCompareLocations = createAction(
  "[Invoke Compare Selected Franchiseds] Invoke compare selected franchiseds",
  props<{ data: ComparatorRequestDto }>()
);

export const resultCompareLocations = createAction(
  "[result Compare Selected Franchiseds] result compare selected franchiseds",
  props<{comparatorResults : ComparatorSummary[] | null}>()
);
